/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_mc_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. Morse code has no case, so text is treated as uppercase. Decoding always produces uppercase letters.`)
};

const es_mc_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. El código Morse no tiene mayúsculas, por lo que el texto se trata como mayúsculas. La decodificación siempre produce letras mayúsculas.`)
};

const de_mc_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nein. Morsecode kennt keine Groß- und Kleinschreibung, daher wird Text als Großschreibung behandelt. Das Dekodieren erzeugt immer Großbuchstaben.`)
};

const nl_mc_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nee. Morsecode heeft geen case, dus tekst wordt behandeld als hoofdletters. Decodering produceert altijd hoofdletters.`)
};

const fr_mc_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non. Le code Morse n'a pas de notion de casse, donc le texte est traité comme étant en majuscules. Le décodage produit toujours des lettres majuscules.`)
};

const it_mc_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. Il codice Morse non ha maiuscole/minuscole, quindi il testo è trattato come maiuscolo. La decodifica produce sempre lettere maiuscole.`)
};

const pt_br2_mc_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não. O código Morse não tem maiúsculas/minúsculas, então o texto é tratado como maiúsculo. A decodificação sempre produz letras maiúsculas.`)
};

const pt_mc_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não. O código Morse não tem maiúsculas/minúsculas, portanto o texto é tratado como maiúscula. A decodificação sempre produz letras maiúsculas.`)
};

const ja_mc_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`いいえ。モールス信号には大文字と小文字がないため、テキストは大文字として扱われます。デコードは常に大文字を生成します。`)
};

const zh_mc_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不区分。摩尔斯电码没有大小写之分，因此文本会被视为大写处理。解码结果始终以大写字母呈现。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const mc_faq3_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.mc_faq3_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("mc_faq3_a", locale)
	if (locale === "en") return en_mc_faq3_a(inputs)
	if (locale === "es") return es_mc_faq3_a(inputs)
	if (locale === "de") return de_mc_faq3_a(inputs)
	if (locale === "nl") return nl_mc_faq3_a(inputs)
	if (locale === "fr") return fr_mc_faq3_a(inputs)
	if (locale === "it") return it_mc_faq3_a(inputs)
	if (locale === "pt-BR") return pt_br2_mc_faq3_a(inputs)
	if (locale === "pt") return pt_mc_faq3_a(inputs)
	if (locale === "ja") return ja_mc_faq3_a(inputs)
	return zh_mc_faq3_a(inputs)
};